module.exports = __webpack_public_path__ + "img/print-filled-white.f5a8113b.svg";